require('babel-polyfill')
require('es6-promise').polyfill()
import Vue from 'vue'

import UmyUi from 'umy-ui'
import 'umy-ui/lib/theme-chalk/index.css'// 引入样式

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import i18n from './lang' // Internationalization
import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import axios from 'axios'
Vue.prototype.$http = axios

import { Drawer, Timeline, TimelineItem, Switch } from 'iview'
import 'iview/dist/styles/iview.css'
Vue.component('Drawer', Drawer)
Vue.component('Timeline', Timeline)
Vue.component('TimelineItem', TimelineItem)
Vue.component('i-switch', Switch)

import '@/icons' // icon
import '@/permission' // permission control

import waves from '@/directive/waves/index.js' // 水波纹
import elDragDialog from '@/directive/el-dragDialog' // 拖动dialog
import elDragWidth from '@/directive/el-dragWidth' // 拖动dialog
import intervalClick from '@/directive/intervalClick'
Vue.directive('waves', waves) // 水波纹
Vue.directive('elDragDialog', elDragDialog) // 拖动dialog
Vue.directive('elDragWidth', elDragWidth) // 拖动dialog
Vue.directive('intervalClick', intervalClick)
Vue.directive('loadmore', {
  bind(el, binding) {
    const selectWrap = el.querySelector('.el-table__body-wrapper')
    selectWrap.addEventListener('scroll', function () {
      const sign = 5
      const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
      if (scrollDistance <= sign) {
        binding.value()
      }
    })
  }
})

// window.onbeforeunload = () => { }
// window.onbeforeunload = () => {
//   return '是否确定离开页面？'
// }
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
  size: 'small'
})
Vue.use(UmyUi)
const bus = new Vue()
Vue.prototype.$bus = bus
Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
